import * as React from 'react';
import { Chips } from '@cian/ui-kit';

import { newbuildingClassDescriptor } from '../../constants/descriptors';
import { isDescriptorActive } from '../../utils/filters';
import { connectToDescriptors, IDescriptorProps } from '../сonnectToDescriptors';
import { TTypedThunkDispatch } from '../../types/thunk';
import { getOffersCount } from '../../actions/offersData';

export interface INewbuildingClassProps extends IDescriptorProps<string> {
  getOffersCount(): void;
}

export const NewbuildingClassComponent: React.FC<INewbuildingClassProps> = React.memo(
  ({ actionCreator, getOffersCount, jsonQuery, descriptors }) => {
    const options = React.useMemo(
      () =>
        descriptors.map(({ state, label }) => ({
          label,
          value: state,
        })),
      [descriptors],
    );

    const activeDescriptors = descriptors.filter(descriptor => isDescriptorActive(descriptor)(jsonQuery));
    const currentValues = React.useMemo(() => activeDescriptors.map(d => d.state), [activeDescriptors]);

    const handleChipClick = React.useCallback(
      (value: string) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        actionCreator(descriptors.find(d => d.state === value)!)();
        getOffersCount();
      },
      [actionCreator, descriptors, getOffersCount],
    );

    return (
      <Chips options={options} size="M" value={currentValues} selectType="multiple" onChipClick={handleChipClick} />
    );
  },
);

NewbuildingClassComponent.displayName = 'NewbuildingClassComponent';

function mapDispatchToProps(dispatch: TTypedThunkDispatch) {
  return {
    getOffersCount: () => {
      dispatch(getOffersCount());
    },
  };
}

export const NewbuildingClass = connectToDescriptors(
  newbuildingClassDescriptor,
  mapDispatchToProps,
)(NewbuildingClassComponent);
